import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import '../../css/components/Profile/ProfileError.css';

const ProfileError = ({ isMobile }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleLoginRedirect = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="profile-error">
      <div className="profile-error-content">
        <h2 className="profile-error-title">{t('profile.authenticationRequired')}</h2>
        <p className="profile-error-message">
          {t('profile.loginRequiredMessage')}
        </p>
        <p className="profile-error-submessage">
          {t('profile.loginRequiredSubmessage')}
        </p>
        <button 
          onClick={handleLoginRedirect}
          className="profile-error-button"
        >
          {t('profile.goToLogin')}
        </button>
      </div>
    </div>
  );
};

export default ProfileError; 